import { useQuery } from '@tanstack/react-query'
import { getImageSlots } from '@/lib/api/amazon-listing'

export { useSlotGenerate, useSlotRerun, useSlotSelect } from './useSlotMutations'

export function useImageSlots(remakeId: string | undefined) {
  return useQuery({
    queryKey: ['image-slots', remakeId],
    queryFn: () => getImageSlots(remakeId!),
    enabled: !!remakeId,
    refetchInterval: (query) => {
      const slots = query.state.data
      if (!slots) return 3000
      const anyGenerating = slots.some(s => s.status === 'generating')
      return anyGenerating ? 3000 : false
    },
  })
}
